export const aboutJebelLink = 'https://jebelapp.com';
